import React, { useEffect, useState } from "react";
import moment from "moment";
import * as Yup from "yup";
import { 
  PreviousMatrixForm, 
  // Layout 
} from "@hedgefund/shared";
import { createPerformanceMetrix } from "./actions";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
const PreviousPerformanceMatrix = ({ location }) => {
  const fundState = useSelector((state) => state.createPerformanceMetrix);
  const [message, setMessage] = useState(null);
  const [monthList, setMonthList] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();

  const { state } = location;
  const { id, date } = state || {};

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const validationArray = monthList.map((item, index) => {
    return {
      [`monthlyReturn${index}`]: Yup.number().required(
        "Monthly Return is Required."
      ),
      initialization: {
        [`monthlyReturn${index}`]: "",
      },
    };
  });

  useEffect(() => {
    const currentDate = moment().format("MMMM YYYY");
    const initializeDate = date && moment(date).format("MMMM YYYY");
    const item = getMonthByDate(initializeDate, currentDate);
    setMonthList(item);
  }, []);

  const getMonthByDate = (from, to) => {
    const arr = [];
    const datFrom = new Date("1 " + from);
    const datTo = new Date("1 " + to);
    const fromYear = datFrom.getFullYear();
    const toYear = datTo.getFullYear();
    const diffYear = 12 * (toYear - fromYear) + datTo.getMonth();

    for (let i = datFrom.getMonth(); i <= diffYear; i++) {
      arr.push(monthNames[i % 12] + " " + Math.floor(fromYear + i / 12));
    }

    return arr;
  };

  const toObject = (arr) => {
    let yupObject = {};
    let initializationObject = {};
    arr.map((item, i) => {
      yupObject[`monthlyReturn${i}`] = item[`monthlyReturn${i}`];

      initializationObject[`monthlyReturn${i}`] =
        item?.initialization[`monthlyReturn${i}`];
      initializationObject = Object.assign({}, initializationObject);
      yupObject = Object.assign({}, yupObject);
    });

    return { yupObject, initializationObject };
  };

  const { initializationObject, yupObject } = toObject(validationArray) || {};

  const onSuccess = () => {
    if (!fundState.loading) {
      setMessage(true);
    } else {
      setMessage(false);
    }
  };
  const onSubmitPerformanceMatrix = (values) => {
    dispatch(createPerformanceMetrix(values, onSuccess));
    setTimeout(() => history.push("/hedgefunds"), 500);
  };

  return (
    Object.keys(initializationObject).length > 0 && (
      <PreviousMatrixForm
        id={id}
        initializationDate={date}
        onSubmitPerformanceMatrix={onSubmitPerformanceMatrix}
        message={message}
        loading={fundState?.loading}
        yupObject={yupObject}
        initialValues={initializationObject}
        monthList={monthList}
      />
    )
  );
};

export default PreviousPerformanceMatrix;
